<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'備份系統資訊'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-table>
              <md-table-row>
                <md-table-head>操作</md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  <a @click="getRecordBackup">紀錄備份</a>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  <a @click="getDoctorBackup">治療師備份</a>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  <a @click="getPatientBackup">客戶備份</a>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="goItemList">返回</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {}
  },
  components: {
    PageTitle
  },
  created: function () {},
  methods: {
    getDoctorBackup: function () {
      axios({
        method: 'post',
        url: urls({route: 'system-op/backup-org/doctor'}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '備份治療師.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    getPatientBackup: function () {
      axios({
        method: 'post',
        url: urls({route: 'system-op/backup-org/patient'}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '備份客戶紀錄.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    getRecordBackup: function () {
      axios({
        method: 'post',
        url: urls({route: 'system-op/backup-org/record'}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '備份服務紀錄.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Backup/Backup.vue